import { useLingui } from "@lingui/react/macro"

interface Props {
  className?: string
}

export function WebsiteIcon(props: Props) {
  const { t } = useLingui()

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      {...props}
    >
      <title>{t`Website Icon`}</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.12087 7.45455H5.30005C5.42234 5.94735 5.92678 4.50059 6.75948 3.249C4.81935 3.75417 3.34619 5.41631 3.12087 7.45455ZM8 3.39135C7.08927 4.56469 6.53207 5.97463 6.39505 7.45455H9.60495C9.46793 5.97463 8.91073 4.56469 8 3.39135ZM9.60495 8.54545C9.46793 10.0254 8.91073 11.4353 8 12.6087C7.08927 11.4353 6.53207 10.0254 6.39505 8.54545H9.60495ZM5.30005 8.54545H3.12087C3.34619 10.5837 4.81935 12.2458 6.75948 12.751C5.92678 11.4994 5.42234 10.0526 5.30005 8.54545ZM9.24052 12.751C10.0732 11.4994 10.5777 10.0526 10.6999 8.54545H12.8791C12.6538 10.5837 11.1807 12.2458 9.24052 12.751ZM12.8791 7.45455H10.6999C10.5777 5.94735 10.0732 4.50059 9.24052 3.249C11.1806 3.75417 12.6538 5.41631 12.8791 7.45455ZM2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8Z"
        fill="currentColor"
      />
    </svg>
  )
}
